import { atom } from "recoil";

export const GroupPlaceTypeState = atom({
    key: "GroupPlaceTypeState",
    default: null,
});